// extracted by mini-css-extract-plugin
module.exports = {"qrWrapper":"QrCode_qrWrapper__Zz060","noShadow":"QrCode_noShadow__GKSP9"};